<template>
  <div id="cancellations-list">
    <table class="table" v-if="$store.state.responsive.viewDesktopLists">
      <thead class="fixheader">
        <tr>
          <!-- <th class="col-2 align-middle">
            <ThOrder :textHeader="'Nombre'" :idHeader="'name'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th> -->
          <!-- <th class="col-2 align-middle">
            <ThOrder :textHeader="'Apellidos'" :idHeader="'surnames'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th> -->
          <!-- <th class="col-1 align-middle">
            <ThOrder :textHeader="'DNI'" :idHeader="'documentNumber'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th> -->
          <th class="col-2 align-middle">
            <ThOrder :textHeader="'Nº Contrato'" :idHeader="'contractNumber'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="col-2 align-middle">
            <ThOrder :textHeader="'Nº Tienda'" :idHeader="'storeNumber'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="col-2 align-middle">
            <ThOrder :textHeader="'Seguimiento'" :idHeader="'tracking'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="col-2 align-middle">
            <ThOrder :textHeader="'Nº Solicitud'" :idHeader="'applicationNumber'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <!-- <th class="col-1 align-middle">
            <ThOrder :textHeader="'Email'" :idHeader="'email'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th> -->
          <!-- <th class="col-1 align-middle">
            <ThOrder :textHeader="'Móvil'" :idHeader="'phone'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th> -->
          <th class="col-2 align-middle">
            <ThOrder :textHeader="'Fecha solicitud'" :idHeader="'createdDate'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="col-2 align-middle thEstado">
            <ThOrder :textHeader="'Estado solicitud'" :idHeader="'contractStatus'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="col-1 align-middle thOperaciones"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(cancellation, index) in cancellationsAux" v-bind:key="cancellation.clientId">
          <!-- <td class="align-middle py-4">{{ cancellation.customer.name }}</td> -->
          <!-- <td class="align-middle py-4">{{ cancellation.customer.surnames }}</td> -->
          <!-- <td class="align-middle py-4">{{ cancellation.customer.legalIdentifier }}</td> -->
          <td class="align-middle py-4">{{ cancellation.contractId }}</td>
          <td class="align-middle py-4">{{ cancellation.storeNumber }}</td>
          <td class="align-middle py-4">{{ cancellation.tracking }}</td>
          <td class="align-middle py-4">{{ cancellation.requestCancellationId }}</td>
          <!-- <td class="align-middle py-4">{{ cancellation.customer.email }}</td> -->
          <!-- <td class="align-middle py-4">{{ cancellation.customer.phone }}</td> -->
          <td class="align-middle py-4">{{ $dateBackToFront(cancellation.transactionDate, true) }}</td>
          <td class="align-middle py-4 tdEstado" :title="getTitle(cancellation.status)">
            <span v-if="cancellation.status == 'COMPLETED'"
              class="badge text-success border border-success">COMPLETED</span>
            <span v-if="cancellation.status == 'CREATED'" class="badge text-info border border-info">CREATED</span>
            <span v-if="cancellation.status == 'REVIEWED_OK'" class="badge text-primary border border-primary">REVISED
              WITHOUT DEFECTS</span>
            <span v-if="cancellation.status == 'EXPIRED'"
              class="badge text-warning border border-warning">EXPIRED</span>
            <span v-if="cancellation.status == 'EXECUTED'"
              class="badge text-success border border-success">EXECUTED</span>
            <span v-if="cancellation.status == 'REVIEWED_DEFECTS'"
              class="badge text-warning border border-warning">REVISED WITH DEFECTS</span>
            <span v-if="cancellation.status == 'CANCELLED'"
              class="badge text-danger border border-danger">CANCELLED</span>
            <span v-if="cancellation.status == 'DELIVERED'"
              class="badge text-danger border border-danger">DELIVERED</span>
             <span v-if="cancellation.status == 'PROCESS_STARTED'"
              class="badge text-info border border-info">PROCESS STARTED</span>
             <span v-if="cancellation.status == 'PAYMENT_HOLD_SUBMITTED'"
              class="badge text-info border border-info">PAYMENT HOLD SUBMITTED</span>
             <span v-if="cancellation.status == 'LOGISTIC_PICKUP_REQUESTED'"
              class="badge text-info border border-info">LOGISTIC PICKUP REQUESTED</span>
          </td>
          <td id="operaciones" class="align-middle py-4 tdOperaciones">
            <div class="dropdown dropdown-inherit">
              <span v-if="cancellation.status == 'CREATED' || cancellation.status == 'DELIVERED' || cancellation.status == 'LOGISTIC_PICKUP_REQUESTED'" id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <v-icon name="fa-ellipsis-v" />
              </span>
              <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                <a v-if="cancellation.status == 'LOGISTIC_PICKUP_REQUESTED'" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, cancellation.contractId, cancellation.requestCancellationId,'DELIVERED', 'RecibirDispositivo', 'modalCancellation', 'Recibir dispositivo')">Recibir dispositivo</a>
                <a v-if="cancellation.status == 'CREATED'" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, cancellation.contractId, cancellation.requestCancellationId, 'CANCELLED', 'Cancelar', 'modalCancellation', 'Cancelación')">Cancelar</a>
                <a v-if="cancellation.status == 'DELIVERED'" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, cancellation.contractId, cancellation.requestCancellationId, 'REVIEWED_DEFECTS', 'RevisadoConDefectos', 'modalCancellation', 'Revisado con defectos')">Revisado con defectos</a>
                <a v-if="cancellation.status == 'DELIVERED'" class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, cancellation.contractId, cancellation.requestCancellationId, 'REVIEWED_OK', 'RevisadoSinDefectos', 'modalCancellation', 'Revisado sin defectos')">Revisado sin defectos</a>
                 <a v-if="cancellation.status == 'CREATED'" class="dropdown-item py-3 px-4" href="#"
                    @click="openModals(index, cancellation.contractId, cancellation.requestCancellationId, 'PROCESS_STARTED', 'StartProcess', 'modalCancellation', 'Iniciar proceso')">Iniciar proceso</a>
                <a class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, cancellation.contractId, '', '', '', 'modalInfoUser')">Ver información</a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <template v-if="!$store.state.responsive.viewDesktopLists">
      <div class="card p-2 mb-3" v-for="(cancellation, index) in cancellationsAux" v-bind:key="cancellation.clientId">
        <div class="list-item">
          <div class="item d-flex align-items-center justify-content-between px-2 py-3" data-toggle="collapse"
            :href="'#collapseExample' + index" role="button" aria-expanded="true"
            :aria-controls="'collapseExample' + index">
            <h4 class="m-0">{{ cancellation.contractId }}</h4>
            <v-icon name="bi-chevron-up" />
          </div>
          <div class="collapse show ml-3 mr-2 borderFirstItem" :id="'collapseExample' + index">
            <div class="d-flex align-items-center justify-content-between flex-wrap mb-2 mt-2">
              <div class="d-flex align-items-center justify-content-start">
                <p class="m-0 mr-2"><strong>Nº Contrato: </strong>{{ cancellation.contractId }}</p>
              </div>
              <div>
                <div class="dropdown dropdown-inherit">
                  <span v-if="cancellation.status == 'CREATED' || cancellation.status == 'DELIVERED' || cancellation.status == 'LOGISTIC_PICKUP_REQUESTED'" id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <v-icon name="fa-ellipsis-v" />
                  </span>
                  <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                    <a v-if="cancellation.status == 'LOGISTIC_PICKUP_REQUESTED'" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, cancellation.contractId, cancellation.requestCancellationId,'DELIVERED', 'RecibirDispositivo', 'modalCancellation', 'Recibir dispositivo')">Recibir dispositivo</a>
                    <a v-if="cancellation.status == 'CREATED'" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, cancellation.contractId, cancellation.requestCancellationId, 'CANCELLED', 'Cancelar', 'modalCancellation', 'Cancelación')">Cancelar</a>
                    <a v-if="cancellation.status == 'DELIVERED'" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, cancellation.contractId, cancellation.requestCancellationId, 'REVIEWED_DEFECTS', 'RevisadoConDefectos', 'modalCancellation', 'Revisado con defectos')">Revisado con defectos</a>
                    <a v-if="cancellation.status == 'DELIVERED'" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, cancellation.contractId, cancellation.requestCancellationId, 'REVIEWED_OK', 'RevisadoSinDefectos', 'modalCancellation', 'Revisado sin defectos')">Revisado sin defectos</a>
                    <a class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, cancellation.contractId, '', '', '', 'modalInfoUser')">Ver información</a>
                      <a v-if="cancellation.status == 'CREATED'" class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, cancellation.contractId, cancellation.requestCancellationId, 'PROCESS_STARTED', 'StartProcess', 'modalCancellation', 'Iniciar proceso')">Iniciar proceso</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Nº Tienda: </strong>{{ cancellation.storeNumber }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Seguimiento: </strong>{{ cancellation.tracking }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Nº Solicitud: </strong>{{ cancellation.requestCancellationId }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Fecha solicitud: </strong>{{ $dateBackToFront(cancellation.transactionDate, true) }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Estado solicitud: </strong></p>
              <span v-if="cancellation.status == 'COMPLETED'"
                class="badge text-success border border-success">COMPLETED</span>
              <span v-if="cancellation.status == 'CREATED'" class="badge text-info border border-info">CREATED</span>
              <span v-if="cancellation.status == 'REVIEWED_OK'" class="badge text-primary border border-primary">REVISED
                WITHOUT DEFECTS</span>
              <span v-if="cancellation.status == 'EXPIRED'"
                class="badge text-warning border border-warning">EXPIRED</span>
              <span v-if="cancellation.status == 'EXECUTED'"
                class="badge text-success border border-success">EXECUTED</span>
              <span v-if="cancellation.status == 'REVIEWED_DEFECTS'"
                class="badge text-warning border border-warning">REVISED WITH DEFECTS</span>
              <span v-if="cancellation.status == 'CANCELLED'"
                class="badge text-danger border border-danger">CANCELLED</span>
              <span v-if="cancellation.status == 'DELIVERED'"
                class="badge text-danger border border-danger">DELIVERED</span>
              <span v-if="cancellation.status == 'PROCESS_STARTED'"
                  class="badge text-info border border-info">PROCESS STARTED</span>
              <span v-if="cancellation.status == 'PAYMENT_HOLD_SUBMITTED'"
                  class="badge text-info border border-info">PAYMENT HOLD SUBMITTED</span>
              <span v-if="cancellation.status == 'LOGISTIC_PICKUP_REQUESTED'"
                  class="badge text-info border border-info">LOGISTIC PICKUP REQUESTED</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <ConfirmCancellation :numContract="numContract" :requestCancellationId="requestCancellationId" :statusSelected="statusSelected" :modalSelected="modalSelected"
      :id="'modalCancellation'" :modalTitle="modalTitle" :class="'modal-md'"
      @refreshCancellationList="refreshCancellationList($event)"></ConfirmCancellation>
    <InfoUser :numContract="numContract" :id="'modalInfoUser'" :modalTitle="'INFORMACIÓN'" :class="'modal-lg'"></InfoUser>
  </div>
</template>

<script>
import ThOrder from '../../Shared/ThOrder.vue';
import ConfirmCancellation from './ConfirmCancellation.vue';
import InfoUser from './InfoUser.vue';

import { Modal as ModalBootstrap } from "bootstrap";

export default {
  name: 'CancellationsList',
  props: [
    'cancellations',
  ],
  data() {
    return {
      currentOrder: '',
      currentOrderBy: '',
      numContract: '',
      requestCancellationId: '',
      modalSelected: '',
      statusSelected: '',
      indexCancellation: '',
      cancellationsAux: this.cancellations,
      modalTitle: ''
    };
  },
  updated() {
    this.cancellationsAux = this.cancellations
  },
  components: {
    ThOrder,
    ConfirmCancellation,
    InfoUser
  },
  methods: {
    selectOrder(value) {
      this.cancellationsAux = this.cancellationsAux.sort(function (a, b) {
        let valorA = a[value.orderBy] == null || a[value.orderBy] == undefined ? 0 : a[value.orderBy]
        let valorB = b[value.orderBy] == null || b[value.orderBy] == undefined ? 0 : b[value.orderBy]
        if (value.orderBy == "capacity") {
          valorA = parseInt(a[value.orderBy].slice(0, -2))
          valorB = parseInt(b[value.orderBy].slice(0, -2))
        }
        if (valorA < valorB) return -1
        if (valorA > valorB) return 1
      })
      if (value.order == 'DESC') this.cancellationsAux = this.cancellationsAux.reverse()
    },
    openModals: function (index, id, requestCancellationId, status, title, identifier, modalTitle) {
      this.indexCancellation = index;
      this.numContract = id;
      this.requestCancellationId = requestCancellationId;
      this.statusSelected = status;
      this.modalSelected = title;
      this.modalTitle = modalTitle;
      var myModal = new ModalBootstrap(document.getElementById(identifier))
      myModal.show()
    },
    refreshCancellationList(cancellation) {
      this.cancellationsAux[this.indexCancellation].status = cancellation;
    },
    getTitle(title) {
      switch (title) {
        case 'REVIEWED_OK':
          return 'REVISED WITHOUT DEFECTS';
        case 'REVIEWED_DEFECTS':
          return 'REVISED WITH DEFECTS';
        default:
          return title;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
